import React from 'react';

import TextArea from '@repo/editor/src/components/TextArea';
import { withEventScope } from '@repo/event-processor';
import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { TextAreaError, TextAreaLabel, TextAreaWrapper } from './styles';
import { AiTextToolMainPromptProps } from './types';

const AiTextToolMainPrompt: React.FC<AiTextToolMainPromptProps> = ({
  isLoading,
  textArea,
  error,
  onChange,
  value,
}) => {
  return (
    <TextAreaLabel disabled={isLoading}>
      <P2>{textArea.label}*</P2>
      <TextAreaWrapper disabled={isLoading} error={!!error}>
        <TextArea
          isTextAreaAutoGrowing={true}
          placeholder={textArea.placeholder}
          theme={{
            backgroundColor: themeStyle.varInkSuperLight,
            borderRadius: '10px',
            borderColor: error ? themeStyle.alertRed : themeStyle.varInkLight,
            color: error ? themeStyle.alertRed : themeStyle.varInkMain,
          }}
          value={value}
          onChange={onChange}
        />
        {!!error && <TextAreaError>{error}</TextAreaError>}
      </TextAreaWrapper>
    </TextAreaLabel>
  );
};

export default withEventScope(AiTextToolMainPrompt, {
  module: 'aiTextToolMainPrompt',
});
